/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetEvidences200ResponseInnerWarnings
 */
export interface GetEvidences200ResponseInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerWarnings
     */
    'detectedDpi'?: GetEvidences200ResponseInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerWarnings
     */
    'calculatedDpi'?: GetEvidences200ResponseInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerWarnings
     */
    'colorGradation'?: GetEvidences200ResponseInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerWarnings
     */
    'heightMillis'?: GetEvidences200ResponseInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInnerWarnings
     */
    'widthMillis'?: GetEvidences200ResponseInnerWarningsWidthMillisEnum;
}

export const GetEvidences200ResponseInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidences200ResponseInnerWarningsDetectedDpiEnum = typeof GetEvidences200ResponseInnerWarningsDetectedDpiEnum[keyof typeof GetEvidences200ResponseInnerWarningsDetectedDpiEnum];
export const GetEvidences200ResponseInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidences200ResponseInnerWarningsCalculatedDpiEnum = typeof GetEvidences200ResponseInnerWarningsCalculatedDpiEnum[keyof typeof GetEvidences200ResponseInnerWarningsCalculatedDpiEnum];
export const GetEvidences200ResponseInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetEvidences200ResponseInnerWarningsColorGradationEnum = typeof GetEvidences200ResponseInnerWarningsColorGradationEnum[keyof typeof GetEvidences200ResponseInnerWarningsColorGradationEnum];
export const GetEvidences200ResponseInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidences200ResponseInnerWarningsHeightMillisEnum = typeof GetEvidences200ResponseInnerWarningsHeightMillisEnum[keyof typeof GetEvidences200ResponseInnerWarningsHeightMillisEnum];
export const GetEvidences200ResponseInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidences200ResponseInnerWarningsWidthMillisEnum = typeof GetEvidences200ResponseInnerWarningsWidthMillisEnum[keyof typeof GetEvidences200ResponseInnerWarningsWidthMillisEnum];


